// Tratados entre casas (`diplomacy.basic`) — español. Se une en ./messages.ts.

export const gameTreatyEs = {
  'treaty.war': 'en guerra',
  'treaty.pact': 'pacto',
  'treaty.alliance': 'aliado',
  'treaty.federation': 'federación',
  'treaty.propose.peace': 'Proponer la paz',
  'treaty.propose.pact': 'Proponer un pacto',
  'treaty.propose.alliance': 'Proponer una alianza',
  'treaty.sent': 'Propuesta enviada',
  'treaty.noPoints': 'Puntos de diplomacia insuficientes',
  'treaty.points': 'Puntos de diplomacia {points}/{max} · una propuesta cuesta {cost}',
  'treaty.of.neutral': 'la paz',
  'treaty.of.pact': 'un pacto de no agresión',
  'treaty.of.alliance': 'una alianza',
  'treaty.of.federation': 'una federación',
  'treaty.of.war': 'la guerra',
  'treaty.offerTitle': '{house} ofrece {treaty}',
  'treaty.war.declare': 'Declarar la guerra',
  'treaty.war.confirm': 'Confirmar guerra (−{honor} de honor)',
  'treaty.war.cancel': 'Cancelar',
  'treaty.news.accepted': '{house} aceptó {treaty}',
  'treaty.news.declined': '{house} rechazó {treaty}',
  'treaty.news.expired': 'Tu propuesta a {house} caducó',
  'treaty.news.wed': '{house} aceptó tu matrimonio',
  'treaty.news.refused': '{house} rechazó tu matrimonio',
  'treaty.news.lapsed': 'Tu propuesta de matrimonio a {house} caducó',
  'treaty.news.war': 'Guerra con {house}',
  'treaty.news.taken': 'Tienes {treaty} con {house}',
  'treaty.news.void': '{house} te ofreció {treaty} y no se pudo aceptar',
  'treaty.news.stale': 'Esa propuesta de {house} ya no estaba sobre la mesa',
  'treaty.offers.title': 'Ofertas esperando tu respuesta',
  'treaty.offers.badge': '{count} ofertas esperando',
  'treaty.recent.title': 'Reciente',
  'treaty.accept': 'Aceptar',
  'treaty.decline': 'Rechazar',
} as const;
